module.exports = __webpack_public_path__ + "assets/img/iso27001_img@2x.dcbff5f9.png";